// tslint:disable-next-line variable-name
export const IAuthMachine = Symbol('IAuthMachine')
